
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kyc",
      function () {
        return require("private-next-pages/kyc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kyc"])
      });
    }
  